import React, { Suspense, Fragment, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Loader from "./components/Loader/Loader";
import AdminLayout from "./layouts/AdminLayout";

import GuestGuard from "./components/Auth/GuestGuard";
import AuthGuard from "./components/Auth/AuthGuard";
import PermissionGuard from "./components/Auth/PermissionGuard";

import configs from "./config";

export const renderRoutes = (routes = []) => (
   <Suspense fallback={<Loader />}>
      <Routes>
         {routes.map((route, i) => {
            const Guard = route.guard || Fragment;
            const Layout = route.layout || Fragment;
            const Component = route.component;

            let content = route.routes ? renderRoutes(route.routes) : route.element ? route.element : <Component />;
            if (route.permission) {
               content = <PermissionGuard permission={route.permission}>{content}</PermissionGuard>;
            }

            return (
               <Route
                  key={i}
                  path={route.path}
                  element={
                     <Guard>
                        <Layout>{content}</Layout>
                     </Guard>
                  }
               />
            );
         })}
      </Routes>
   </Suspense>
);

const routes = [
   {
      guard: GuestGuard,
      path: "/auth/signin",
      component: lazy(() => import("./views/Auth/SignIn")),
   },
   {
      guard: GuestGuard,
      path: "/auth/verify",
      component: lazy(() => import("./views/Auth/Verify")),
   },
   {
      guard: AuthGuard,
      path: "/auth/signout",
      component: lazy(() => import("./views/Auth/SignOut")),
   },
   {
      path: "/404",
      component: lazy(() => import("./views/Errors/NotFound404")),
   },
   {
      path: "*",
      layout: AdminLayout,
      guard: AuthGuard,
      routes: [
         {
            path: "/site/dashboard",
            component: lazy(() => import("./views/Site/Dashboard")),
         },
         {
            path: "/site/visitors",
            component: lazy(() => import("./views/Site/Visitors")),
         },
         {
            path: "/email/outemaillogs",
            permission: "email",
            component: lazy(() => import("./views/Emails/SentEmailLogs")),
         },
         {
            path: "/email/inemaillogs",
            permission: "email",
            component: lazy(() => import("./views/Emails/ReceivedEmailLogs")),
         },
         {
            path: "/my/drive",
            permission: "cloud",
            component: lazy(() => import("./views/MyCloud/Drive")),
         },
         {
            path: "/account/billing",
            component: lazy(() => import("./views/Account/Billing")),
         },
         {
            path: "/account/billing/payment",
            component: lazy(() => import("./views/Account/Billing/Payment")),
         },
         {
            path: "*",
            element: <Navigate to={configs.BASE_URL} replace />,
         },
      ],
   },
];

export default routes;
